// extracted by mini-css-extract-plugin
module.exports = {"productAccordionBlock":"styles_productAccordionBlock__oCvvR","showMoreButton":"styles_showMoreButton___dZms"};